module.exports = __webpack_public_path__ + "static/saas-pricing-ab-b637667840f2850700588b13181126e7.png";